import { MetricField } from "../../gql-generated/types";

export const TopLensesOptions = [
    { value: MetricField.LensPlays, label: "Top Played Lenses" },
    { value: MetricField.Favorites, label: "Top Favorited Lenses" },
];
